import type { PlanState } from './types'
import { type PlanAction, PlanActionType } from '../actions/PlanActions'

export const initialPlanState: PlanState = {
  companyName: '',
  buildingType: '',
  buildingQuantity: 1,
  stairwellQuantity: 1,
  floorQuantity: 1,
  apartmentQuantity: undefined,
  centralUnitPlacedInMiddle: '',
  waterMeterType: '',
  moreThanOneMeterPerApartment: '',
  meterSize: '',
  apartmentScreensEnabled: '',
  systemType: '',
  temperatureMetersEnabled: '',
  wirelessMode: '',
  smokeDetectorType: 'none'
}

export function planReducer (state = initialPlanState, action: PlanAction): PlanState {
  if (action.type === PlanActionType.CHOOSE_BUILDING_TYPE) {
    return { ...state, buildingType: action.payload.buildingType }
  }
  if (action.type === PlanActionType.UPDATE_PLAN) {
    return { ...state, ...action.payload }
  }
  return state
}
